import { InterventionTableQuery } from "../../../interventions/models";

export const defaultHomeInterventionsTableQuery: InterventionTableQuery = {
  page: 1,
  pageSize: 10,
};
